export default __webpack_public_path__ + "static/media/bitcoin_airdrop_large.8474c30a.png";